import { ColDef } from 'ag-grid-community';
import {
  footprintStatusGetter,
  milestoneStatusGetter,
  updatedDateGetter,
  createdDateGetter,
  contentTypeGetter,
  seriesTitleGetter,
  seasonTitleGetter,
  titleGetter,
  entityTypeGetter,
  latestCommentGetter,
  milestoneDetailGetter,
  milestoneDateGetter,
  milestoneCodeGetter,
  complianceGetter,
  hdrFrameSizeGetter,
  sdrFrameSizeGetter,
  hdrPictureAspectRatioGetter,
  sdrPictureAspectRatioGetter,
  hdrScanningFormatGetter,
  sdrScanningFormatGetter,
  ratingsGetter,
  uploadedByGetter
} from './acquireValueGetters';
import { comparator, dateComparator } from '../comparators';
import {
  fulfilledAudioComponentsGetter,
  fulfilledTimedTextComponentsGetter,
  fulfilledMarkersGetter,
  fulfilledAnnotationslabelsGetter,
  fulfilledMediaDurationGetter,
  dynamicRangeIndicatorGetter
} from './acquireValueGetters';
import { taskCIDGetter } from '../columnsHelpers/globalValueGetters';
import {
  activePresManifAudioComponentsGetter,
  activePresManifTimedTextComponentsGetter,
  activePresManifMarkersGetter,
  activePresManifAnnotationslabelsGetter,
  activePresManifMediaDurationGetter,
  activePresManifDynamicRangeIndicatorGetter
} from '../columnsHelpers/activePresManifCompGetters';

export function SetAcquireValueGetters(columnDefs: ColDef[]) {
  columnDefs.forEach((cd) => {
    let keys = Object.keys(cd);
    if (keys.includes('valueGetter')) {
      if (typeof cd.valueGetter === 'string') {
        switch (cd.valueGetter) {
          case 'footprintStatusGetter':
            cd.valueGetter = footprintStatusGetter;
            break;
          case 'createdDateGetter':
            cd.valueGetter = createdDateGetter;
            break;
          case 'updatedDateGetter':
            cd.valueGetter = updatedDateGetter;
            break;
          case 'milestoneStatusGetter':
            cd.valueGetter = milestoneStatusGetter;
            break;
          case 'contentTypeGetter':
            cd.valueGetter = contentTypeGetter;
            break;
          case 'seriesTitleGetter':
            cd.valueGetter = seriesTitleGetter;
            break;
          case 'seasonTitleGetter':
            cd.valueGetter = seasonTitleGetter;
            break;
          case 'titleGetter':
            cd.valueGetter = titleGetter;
            break;
          case 'entityTypeGetter':
            cd.valueGetter = entityTypeGetter;
            break;
          case 'latestCommentGetter':
            cd.valueGetter = latestCommentGetter;
            break;
          case 'milestoneDetailGetter':
            cd.valueGetter = milestoneDetailGetter;
            break;
          case 'milestoneDateGetter':
            cd.valueGetter = milestoneDateGetter;
            break;
          case 'milestoneCodeGetter':
            cd.valueGetter = milestoneCodeGetter;
            break;
          case 'fulfilledAudioComponentsGetter':
            cd.valueGetter = fulfilledAudioComponentsGetter;
            break;
          case 'fulfilledTimedTextComponentsGetter':
            cd.valueGetter = fulfilledTimedTextComponentsGetter;
            break;
          case 'fulfilledMarkersGetter':
            cd.valueGetter = fulfilledMarkersGetter;
            break;
          case 'fulfilledAnnotationslabelsGetter':
            cd.valueGetter = fulfilledAnnotationslabelsGetter;
            break;
          case 'fulfilledMediaDurationGetter':
            cd.valueGetter = fulfilledMediaDurationGetter;
            break;
          case 'dynamicRangeIndicatorGetter':
            cd.valueGetter = dynamicRangeIndicatorGetter;
            break;
          case 'fulfilledAudioComponentsGetter':
            cd.valueGetter = fulfilledAudioComponentsGetter;
            break;
          case 'fulfilledTimedTextComponentsGetter':
            cd.valueGetter = fulfilledTimedTextComponentsGetter;
            break;
          case 'fulfilledMarkersGetter':
            cd.valueGetter = fulfilledMarkersGetter;
            break;
          case 'fulfilledAnnotationslabelsGetter':
            cd.valueGetter = fulfilledAnnotationslabelsGetter;
            break;
          case 'fulfilledMediaDurationGetter':
            cd.valueGetter = fulfilledMediaDurationGetter;
            break;
          case 'dynamicRangeIndicatorGetter':
            cd.valueGetter = dynamicRangeIndicatorGetter;
            break;
          case 'uploadedByGetter':
            cd.valueGetter = uploadedByGetter;
            break;
          case 'complianceGetter':
            cd.valueGetter = complianceGetter;
            break;
          case 'hdrFrameSizeGetter':
            cd.valueGetter = hdrFrameSizeGetter;
            break;
          case 'sdrFrameSizeGetter':
            cd.valueGetter = sdrFrameSizeGetter;
            break;
          case 'hdrPictureAspectRatioGetter':
            cd.valueGetter = hdrPictureAspectRatioGetter;
            break;
          case 'sdrPictureAspectRatioGetter':
            cd.valueGetter = sdrPictureAspectRatioGetter;
            break;
          case 'hdrScanningFormatGetter':
            cd.valueGetter = hdrScanningFormatGetter;
            break;
          case 'sdrScanningFormatGetter':
            cd.valueGetter = sdrScanningFormatGetter;
            break;
          case 'taskCIDGetter':
            cd.valueGetter = (params) =>
              taskCIDGetter(params?.data?.tasks, 'manifestationregistration');
            break;
          case 'ratingsGetter':
            cd.valueGetter = ratingsGetter;
            break;
          case 'activePresManifAudioComponentsGetter':
            cd.valueGetter = activePresManifAudioComponentsGetter;
            break;
          case 'activePresManifTimedTextComponentsGetter':
            cd.valueGetter = activePresManifTimedTextComponentsGetter;
            break;
          case 'activePresManifMarkersGetter':
            cd.valueGetter = activePresManifMarkersGetter;
            break;
          case 'activePresManifAnnotationslabelsGetter':
            cd.valueGetter = activePresManifAnnotationslabelsGetter;
            break;
          case 'activePresManifMediaDurationGetter':
            cd.valueGetter = activePresManifMediaDurationGetter;
            break;
          case 'activePresManifDynamicRangeIndicatorGetter':
            cd.valueGetter = activePresManifDynamicRangeIndicatorGetter;
            break;
          default:
            break;
        }
      }
    }
    if (keys.includes('comparator')) {
      if (typeof cd.comparator === 'string') {
        switch (cd.comparator) {
          case 'comparator':
            cd.comparator = comparator;
          case 'dateComparator':
            cd.comparator = dateComparator;
        }
      }
    }
  });
}
